var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.007 13.337a.585.585 0 01-.524-.324 7.32 7.32 0 011.371-8.47c2.859-2.86 7.51-2.86 10.37 0a.586.586 0 01-.83.828 6.167 6.167 0 00-10.44 3.372 6.15 6.15 0 00.577 3.745.586.586 0 01-.524.849zM10.039 17.055a7.308 7.308 0 01-5.185-2.143.586.586 0 01.829-.83 6.167 6.167 0 0010.44-3.372 6.15 6.15 0 00-.577-3.745.586.586 0 111.048-.525 7.33 7.33 0 01-6.555 10.615z",
    fill: "#879494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.313 5.791a.586.586 0 01-.058-1.169l1.853-.184-.372-1.863a.587.587 0 011.15-.228l.497 2.497a.585.585 0 01-.516.697l-2.496.25h-.059zM5.766 17.578a.586.586 0 01-.575-.471l-.497-2.495a.586.586 0 01.517-.698l2.495-.249a.586.586 0 01.117 1.166l-1.853.185.371 1.862a.586.586 0 01-.575.7z",
    fill: "#879494"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconRefresh.587e6bdd.svg";
export { MemoForwardRef as ReactComponent };